export const RIDER_PORTAL_APP_TYPE = 'RIDER_APP'
export const RIDER_PORTAL_MAIN_PATH = '/rider-portal'
export const RIDER_PORTAL_USER_TYPE = 'RIDER_PORTAL_USER'

export const PORTAL_DAYS_MAPPING = {
  sun: 'Sunday',
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday'
}

export const PORTAL_INPUT_PROPS = {
  inputStyle: 'outline' as const,
  theme: 'ios'
}

export const PORTAL_CALENDAR_PROPS = {
  ...PORTAL_INPUT_PROPS,
  touchUi: false
}

export const RIDER_PORTAL_UI_MESSAGES = {
  auth: {
    accessYourAccount: 'Sign in to access your account, book rides, and manage your profile.',
    enterOtp: 'Enter your One-Time Password',
    invalidPhoneNumber: 'Invalid phone number',
    otpRecipient: 'One-Time Password Recipient',
    rememberMe: 'Remember me for 30 days',
    resendOTP: 'Resend One-Time Password',
    sendOTP: 'Send One-Time Password',
    sendOTPtoEmail: 'Send one-time password to registered email',
    signIn: 'Sign In',
    signinToAccount: 'Sign In To Your Account',
    welcomeBack: 'Welcome Back'
  },
  common: {
    back: 'Back',
    cancel: 'Cancel',
    continue: 'Continue',
    date: 'Date',
    driver: 'Driver',
    email: 'Email',
    fare: 'Fare',
    goin: "GOIN'",
    notes: 'Notes',
    map: 'Map',
    phoneNumber: 'Phone Number',
    rideNow: 'Ride Now',
    passengers: 'Passengers',
    price: 'Price',
    processing: 'Processing',
    product: 'Product',
    schedule: 'Schedule',
    search: 'Search',
    service: 'Service',
    sms: 'SMS',
    time: 'Time',
    trip: 'Trip',
    types: 'Types',
    vehicle: 'Vehicle'
  },
  dataFeedback: {
    locationOutOfServiceZone: 'Selected location is out of Service Zone',
    noAvailableProducts: 'No available products',
    noDataAvailable: 'No data available.',
    noDescriptionAvailable: 'No description available',
    noOptionAvailable: 'No option available',
    noPaymentSource: 'No credit card source found. Please select other payment method',
    noSchedulesFound: 'No schedules found.',
    noServicesFound: 'No services found. Please ensure your device’s location is enabled and try again.',
    pleaseAllowToUseLocation: 'Please allow us to use your device current location.',
    pleaseSelectAnOption: 'Please select an option',
    pleaseSpecifyDestination: 'Please specify your destination',
    redirectNotification: 'You will be redirected to your booking details',
    retrievingLocations: 'Retrieving locations...',
    retrievingProducts: 'Retrieving products...',
    retrievingProductsOfSelectedService: 'Retrieving products of the selected service...',
    retrievingServices: 'Retrieving services...',
    retrievingTripDetails: 'Retrieving trip details...',
    retrievingRiderInfo: 'Retrieving rider information...'
  },
  footer: {
    aboutUs: 'About Us',
    accessibility: 'Accessibility',
    allRightsReserved: 'All rights reserved',
    contactInfo: 'Contact Info',
    contactUs: 'Contact Us',
    flow: 'Flow',
    goin: "GOIN'",
    goinMyWay: "GOIN' My Way",
    goinTransitFlowPro: "GOIN' Transit Flow Pro",
    faq: 'FAQ',
    home: 'Home',
    quickLinks: 'Quick Links',
    ourProducts: 'Our Products',
    privacy: 'Privacy',
    privacyPolicy: 'Privacy Policy',
    products: 'Products',
    tagLine: 'Reimagining community mobility with innovative and transit solutions.',
    terms: 'Terms',
    termsOfService: 'Terms of Service'
  },
  mobility: {
    cane: 'Cane',
    crutches: 'Crutches',
    mobilityScooter: 'Mobility Scooter',
    oxygenTank: 'Oxygen Tank',
    walker: 'Walker',
    wheelChair: 'Wheelchair'
  },
  placeholder: {
    anySpecialInstructions: 'Any special instructions for the driver...',
    pickupAddress: 'Enter pickup address',
    searchAddress: 'Search for an address'
  },
  services: {
    adaParatransit: 'ADA Paratransit',
    express: 'Express',
    onDemand: 'On-Demand',
    premium: 'Premium'
  },
  trips: {
    accessibilityAndSpecialNeeds: 'Accessibility & Special Needs',
    addPassenger: 'Add Passenger',
    availableServices: 'Available Services',
    bookAnotherRide: 'Book Another Ride',
    bookRide: 'Book Ride',
    bookYourRide: 'Book Your Ride',
    bookingConfirmed: 'Booking Confirmed',
    bookingReference: 'Booking Reference',
    confirmAndPay: 'Confirm & Pay',
    count: 'Count',
    destination: 'Destination',
    estimatedFare: 'Estimated fare',
    estimatedPickup: 'Estimated Pickup',
    finalFareCalculatedAfterTrip: 'Final fare calculated after trip',
    mobilityAids: 'Mobility Aids (select all that apply)',
    nextSchedule: 'Next Schedule',
    numberOfPassengers: 'Number of Passengers',
    passengerDetails: 'Passenger Details (maximum of 6 riders)',
    passengerTypes: 'Passenger Types',
    paymentMethods: 'Payment Methods',
    paymentSource: 'Payment Source',
    pleaseReviewYourDetailsBelow: 'Please review your trip details below',
    pickupLocation: 'Pickup Location',
    recentLocations: 'Recent Locations',
    selectLocation: 'Select Location',
    serviceAndPickup: 'Select Service & Pickup',
    scheduledPickup: 'Scheduled Pickup',
    specialInstructions: 'Special Instructions',
    specialNeedsAndInstructions: 'Special Needs and Instructions',
    specialRequirements: 'Special Requirements',
    travelWithAnimal: 'Traveling with service animal',
    tripDetails: 'Trip Details',
    tripSummary: 'Trip Summary',
    viewAllLocations: 'View all locations',
    viewAllServices: 'View all services',
    wheelChairNeeded: 'Wheelchair accessible vehicle needed',
    details: {
      driverAndVehicle: 'Driver and Vehicle',
      estimatedPickupTime: 'Estimated Pickup Time',
      estimatedTripDuration: 'Estimated Trip Duration',
      totalTripDuration: 'Total Trip Duration',
      tripDetails: 'Trip Details'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/rider-portal.ts